import axios from "axios";

const TRANS_URL = process.env.REACT_APP_TRANSACTION_API_URL;

export const AddDisposalIntimation = async (disposalData) => {
    let url = `${TRANS_URL}/disposalintimation/adddisposalintimation`;
    console.log("TRANS_URL====>", url);
    const response = await axios
        .post(url, disposalData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to find request", status: false } };
        });
    console.log("response.data====>", response.data);
    return response.data;
};

export async function getAllDisposalIntimationForms() {
    const response = await axios
        .get(TRANS_URL + "/disposalintimation/getformdata")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getAllUOM() {
    const response = await axios
        .get(TRANS_URL + "/disposalintimation/getuommaster")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export const deleteDisposalIntimation = async (disposalData) => {
    let url = `${TRANS_URL}/disposalintimation/adddisposalintimation`;
    const response = await axios
        .post(url, disposalData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to delete request", status: false } };
        });
    return response.data;
};

export const addWorkflowEntry = async (intimationNumber, workflowData) => {
    let url = `${TRANS_URL}/disposalintimation/adddisposalworkflow`;

    const serialNumber = await getNextSerialNumber(intimationNumber);

    const workflowEntry = {
        ...workflowData,
        PK: "WorkflowHistory",
        SK: `DisposalIntimation#${intimationNumber}#SerialNo${serialNumber}`,
        SerialNumber: serialNumber,
        DisposalIntimationNumber: intimationNumber
    };

    const response = await axios
        .post(url, workflowEntry)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to find request", status: false } };
        });
    console.log("response.data====>", response.data);
    return response.data;
};

export async function getWorkflowHistory(intimationNumber) {
    const url = `${TRANS_URL}/disposalintimation/getworkflowhistory`;
    const workflowObj = { IntimationNumber: intimationNumber }
    const response = await axios
        .post(url, workflowObj)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getNextSerialNumber(intimationNumber) {
    try {
        const history = await getWorkflowHistory(intimationNumber);
        return history.length + 1;
    } catch (error) {
        console.error("Error getting serial number:", error);
        return;
    }
}

export async function getDisposalIntimationById(intimationNumber) {
    const url = `${TRANS_URL}/disposalintimation/getintimationdata`;
    const workflowObj = { SK: `IntimationNumber#${intimationNumber}` }
    const response = await axios
        .post(url, workflowObj)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getReportsData(filters) {
    const url = `${TRANS_URL}/disposalintimation/getreportsdata`;
    const response = await axios
        .post(url, filters)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getReportsDataWithWorkflow(filters) {
    const reportsData = await getReportsData(filters);

    const enrichedData = await Promise.all(
        reportsData.map(async (item) => {
            const workflowHistory = await getWorkflowHistory(item.IntimationNumber);

            // Find divisional approval
            const divApproval = workflowHistory.find(w =>
                w.Action === 'Approve' && w.PendingWith === 'FINAPPROVER'
            );

            // Find final approval
            const finalApproval = workflowHistory.find(w =>
                w.Action === 'Approve' && w.Status === 'Approved'
            );

            // Find deletion
            const deletion = workflowHistory.find(w => w.Action === 'Delete');

            return {
                ...item,
                DivisionalApproverEmailId: divApproval?.ActionBy || '',
                DivisionalApproverApprovedOn: divApproval?.ActionDate || '',
                DivisionalApproverRemarks: divApproval?.Remarks || '',
                FinalApproverEmailId: finalApproval?.ActionBy || '',
                FinalApproverApprovedOn: finalApproval?.ActionDate || '',
                FinalApproverRemarks: finalApproval?.Remarks || '',
                ReasonForDeletion: deletion?.Remarks || ''
            };
        })
    );

    return enrichedData;
}